import BookingSection from "./BookingSection";

export default function VideoProductionSection() {
  return (
    <section
      className="w-full bg-cover justify-evenly gap-3 lg:gap-20 lg:h-[700px] bg-no-repeat flex max-lg:flex-col flex-row items-center"
      style={{ backgroundImage: "url('/video-bg-2.jpg')" }}
    >
      <div>
        <div className="max-w-7xl mx-auto px-6 pt-10 pb-5 lg:py-20">
          <div className="max-w-xl lg:gap-5 flex flex-col">
            <h1 className="text-3xl lg:text-[4rem] font-bold text-white lg:leading-[3.5rem]">
              Video Production <br /> Sales{" "}
              <span className="text-brand-green">Experts </span>
            </h1>
            <p className="text-white text-md mt-4 lg:text-xl">
              Get 6–8 New Opportunities Every Month
            </p>
          </div>
        </div>
      </div>
      <BookingSection />
    </section>
  );
}
